// Generic type to hold data for multiple different card types
// Maybe down the road I'll just make the other types inherit this
export class RollCard {
    constructor(type, value, timestamp) {
        this.type = type;
        this.value = value;
        this.timestamp = timestamp;
    }
    ;
}
